import React, { useState } from 'react'
import AwsConfig from '../../Config/AwsConfig'
import AutoSuggestionsdata from '../Movie/Autosuggestionsdata'
import GetMoviesCastAndCrew from '../../Services/Queries/GetMoviesCastAndCrew'
import DynamicListMainFieldsUi from './DynamicListMainFieldsUi'
import LoadingSpinner from '../Movie/Loading'

export default function DynamicListMainFields(props) {
  const {
    setImageChanged,
    listData,
    headerLevelPersons,
    setheaderLevelPersons,
    // editMode,
    // initialHeaderPersons,
    setHorizontalImage,
    horizontalImagePresent,
    dynamicListInfo,
    setDisableUpdateButton,
    previewData,
  } = props

  const [loadSpinner, setLoadSpinner] = useState(false)
  const [imageValue, setImageValue] = useState()
  const [autoSuggestion, setAutoSuggestions] = useState([])
  const [filteredNames, setfilteredNames] = useState([])
  const [Name, setName] = useState('')
  const [removedTagPersons, setRemovedTagPersons] = useState([])
  const [duplicate, setDuplicate] = useState(false)
  const [requiredImageSize, setRequiredImageSize] = useState(true)
  function removeDuplicates(arr, idKey) {
    const uniqueIds = new Set()
    const uniqueObjects = []

    for (const obj of arr) {
      if (!uniqueIds.has(obj[idKey])) {
        uniqueIds.add(obj[idKey])
        uniqueObjects.push(obj)
      }
    }

    return uniqueObjects
  }

  let dynamicListImage =
    /*  listData.selectedImage !== undefined || listData.selectedImage !== null
	? ''
	:  */ listData.selectedImage

  if (
    (dynamicListImage !== undefined &&
      dynamicListImage !== null &&
      dynamicListImage !== '' &&
      !dynamicListImage.includes(AwsConfig.cdn_url)) ||
    dynamicListImage.includes('public')
  ) {
    dynamicListImage = AwsConfig.movieCdnUrl + dynamicListImage
  }

  if (dynamicListImage) {
    dynamicListInfo.dynamicListImage = dynamicListImage
  } else {
    delete dynamicListInfo.dynamicListImage
  }

  const imageHorizontal = e => {
    if (e.target.naturalHeight < e.target.naturalWidth) {
      setHorizontalImage(true)
    } else {
      setHorizontalImage(false)
    }
  }

  const handleImage = e => {
    const maxSize = 2 * 1024 * 1024 // 2MB
    if (e.target.files[0].size > maxSize) {
      setRequiredImageSize(false)
      return
    }

    setRequiredImageSize(true)
    setImageChanged(true)
    props.handleListData('dynamicListImage', e.target.files[0])
    setImageValue('')
  }

  let arrayremovedTagPersons = [...removedTagPersons]

  const SelectionFromSuggestion = event => {
    setDisableUpdateButton(false)
    const headerLevelPersonsTemp = [...headerLevelPersons]
    const selectedIndex = filteredNames.findIndex(obj => obj.label === event.target.innerText)
    const isObjectAlreadyExists = (array, idToCheck) =>
      array.some(obj => obj.personID === idToCheck)
    const objectExists = isObjectAlreadyExists(
      headerLevelPersonsTemp,
      autoSuggestion.personHits[selectedIndex].personID,
    )
    setDuplicate(objectExists)
    headerLevelPersonsTemp.push(autoSuggestion.personHits[selectedIndex])
    const arrayObjects = removeDuplicates(headerLevelPersonsTemp, 'personID')
    setheaderLevelPersons(arrayObjects)
    setName('')
    setfilteredNames([])
    setAutoSuggestions([])
    // arrayremovedTagPersons = arrayremovedTagPersons.filter(
    //   item => item !== headerLevelPersonsTemp.map(item => item.personID),
    // )
  }

  const removePersonFromHeaderTaggedPersons = (index, ID) => {
    setDisableUpdateButton(false)
    const headerLevelPersonsTemp = [...headerLevelPersons]

    arrayremovedTagPersons.push(ID)

    arrayremovedTagPersons = arrayremovedTagPersons.filter(item => item !== null)
    arrayremovedTagPersons = arrayremovedTagPersons.filter(
      item => item !== headerLevelPersons.map(item => item.personID),
    )

    setRemovedTagPersons(arrayremovedTagPersons)

    props.setUnTagHeaderLevelPersons(arrayremovedTagPersons)

    headerLevelPersonsTemp.splice(index, 1)
    setheaderLevelPersons(headerLevelPersonsTemp)
  }

  const handleNameChange = async value => {
    setName(value)
    if (value === '') {
      setfilteredNames([])
    }

    if (value.length >= 3) {
      try {
        const moviePersonData = await AutoSuggestionsdata(value)
        const updatedPersonHits = moviePersonData.personHits.map(e => ({ ...e, personID: e.PK }))
        const updatedData = { ...moviePersonData, personHits: updatedPersonHits }
        setAutoSuggestions(updatedData)

        const filteredNames = moviePersonData
          ? moviePersonData.personHits.map(e => ({ label: e.name_En }))
          : []
        setfilteredNames(filteredNames)
        // setfilteredcrewNamesTelugu(filteredcrewNameste)
      } catch {
        setAutoSuggestions([])
        setfilteredNames([])
        // setfilteredcrewNamesTelugu([])
        // console.warn(error)
      }
    }
  }

  //   dynamicListImage.replace(AwsConfig.movieCdnUrl, ''),
  //   // dynamicListImage,
  //   // AwsConfig.cdn_url,
  //   'headerLevelPersonsheaderLevelPersons',
  // )

  const getSrcValue = data => {
    if (data.includes('blob:')) {
      // data.replace(AwsConfig.movieCdnUrl, '').includes(AwsConfig.movieCdnUrl)
      // if (data.includes(AwsConfig.movieCdnUrl)) {
      //   getSrcValue(data)
      while (data.includes(AwsConfig.movieCdnUrl)) {
        data = data.replace(AwsConfig.movieCdnUrl, '')
      }
    } else {
      while (data.includes(AwsConfig.movieCdnUrl)) {
        data = data.replace(AwsConfig.movieCdnUrl, '')
      }

      if (!data.includes(AwsConfig.movieCdnUrl)) {
        data = AwsConfig.movieCdnUrl + data
      }
    }

    if (!data.includes(AwsConfig.movieCdnUrl)) {
      if (data.includes('blob:')) {
        return data
      }

      return AwsConfig.movieCdnUrl + data
    }

    return data
    // dynamicListImage.includes('blob:')
    //   ? dynamicListImage.replace(AwsConfig.movieCdnUrl, '').includes(AwsConfig.movieCdnUrl)
    //     ? dynamicListImage.replace(AwsConfig.movieCdnUrl, '')
    //     : dynamicListImage
    //   : dynamicListImage
  }

  const GetPersons = async () => {
    setLoadSpinner(true)
    const input = {
      movieIDs: previewData.map(moviepersoninfo =>
        moviepersoninfo.PK.includes('movieList#')
          ? moviepersoninfo.SK.includes('Text#')
            ? moviepersoninfo.SK.replace('Text#', '')
            : moviepersoninfo.SK
          : moviepersoninfo.PK,
      ),
    }
    const response = await GetMoviesCastAndCrew(input)
    const headerLevelPersonsTemp = [...headerLevelPersons]

    if (response && response.items) {
      const castAndCrew = response.items ? response.items.map(e => ({ ...e, personID: e.PK })) : []
      headerLevelPersonsTemp.push(...castAndCrew)
      const arrayObjects = removeDuplicates(headerLevelPersonsTemp, 'personID')
      setheaderLevelPersons(arrayObjects)
      setLoadSpinner(false)
      setDisableUpdateButton(false)
    }
  }

  const ClearAllHeaderLevelPersons = () => {
    const headerLevelPersonsTemp = [...headerLevelPersons]
    const removedPersons = headerLevelPersonsTemp.map(e => e.personID)
    arrayremovedTagPersons.push(...removedPersons)
    props.setUnTagHeaderLevelPersons(arrayremovedTagPersons)
    setheaderLevelPersons([])
    setDisableUpdateButton(false)
  }
  // useEffect(() => {
  //   if (editMode) {
  //     setheaderLevelPersons(initialHeaderPersons ? initialHeaderPersons : [])
  //   }
  // }, [initialHeaderPersons])

  return (
    <>
      {loadSpinner && <LoadingSpinner />}
      <DynamicListMainFieldsUi
        listData={listData}
        GetPersons={GetPersons}
        previewData={previewData}
        headerLevelPersons={headerLevelPersons}
        removePersonFromHeaderTaggedPersons={removePersonFromHeaderTaggedPersons}
        Name={Name}
        handleNameChange={handleNameChange}
        SelectionFromSuggestion={SelectionFromSuggestion}
        filteredNames={filteredNames}
        imageValue={imageValue}
        handleImage={handleImage}
        dynamicListImage={dynamicListImage}
        getSrcValue={getSrcValue}
        imageHorizontal={imageHorizontal}
        horizontalImagePresent={horizontalImagePresent}
        handleListData={props.handleListData}
        duplicate={duplicate}
        ClearAllHeaderLevelPersons={ClearAllHeaderLevelPersons}
        requiredImageSize={requiredImageSize}
      />
    </>
  )
}
